<template lang="pug">
v-row#projects.py-6.px-1(no-gutters, justify='center')
  v-col
    v-expansion-panels(v-model='panel')
      v-expansion-panel.my-1(v-if='inProgressPopulated')
        person-expansion-header(
          icon='mdi-progress-clock',
          :title='t("person.inProgress")'
        )
        v-expansion-panel-text
          #projects-in-progress.mb-10(
            v-for='(project, i) in projects.inProgress'
          )
            person-project(:project='project')
            v-divider

      v-expansion-panel.my-1(v-if='definitelyFinishedPopulated')
        person-expansion-header(
          icon='mdi-check-all',
          :title='t("person.definitelyFinished")'
        )
        v-expansion-panel-text
          #projects-finished.mb-10(
            v-for='(project, i) in projects.definitelyFinished'
          )
            person-project(:project='project')
            v-divider
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import type { PersonalProjects } from '~/interfaces/project'

defineOptions({
  name: 'PersonProjects',
})

const props = defineProps({
  projects: {
    type: Object as () => PersonalProjects,
    required: true,
  },
})

const panel = ref(0)
const { t } = useI18n()

const inProgressPopulated = computed(() => {
  return props.projects.inProgress.length > 0
})

const definitelyFinishedPopulated = computed(() => {
  return props.projects.definitelyFinished.length > 0
})
</script>
